module.exports = __webpack_public_path__ + "static/img/logo_2.75bac09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_2.png
// module id = 2Q6y
// module chunks = 1